import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FeatureTogglesFacade } from '@cigna/features';
import { OmniCommChannelFacade } from '@cigna/omni/comm-channel-feature';
import { OmniAnalyticsService } from '@cigna/omni/shared';
import { OutroObj } from '../interfaces/outro.interface';

@Component({
  selector: 'cigna-omni-messaging-outro',
  templateUrl: './outro.component.html',
  styleUrls: ['./outro.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OmniMessagingOutroComponent {
  @Input() outro: OutroObj;
  @Input() isHistory: boolean;
  @Input() shouldEnablePreChatWelcome: boolean;
  @Input() agentLeftMessageCopy: string;
  @Input() public isEapUser: boolean;
  isEvernorthEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isEvernorthEnabled',
  ]);

  constructor(
    private featureTogglesFacade: FeatureTogglesFacade,
    private commChannelFacade: OmniCommChannelFacade,
    private analytics: OmniAnalyticsService,
  ) {}

  public backTostart() {
    const paramTags = this.isEapUser ? ['advocate', 'member'] : ['default'];
    this.commChannelFacade.interact(
      {
        buttonText: 'Chat with a Guide',
        buttonId: 'chatGuide',
      },
      { tags: paramTags },
    );
  }

  downloadTranscript() {
    const innerContents = document.querySelector('#printSection')?.innerHTML;
    const printWindow = window.open('', '_blank');
    if (printWindow && innerContents) {
      printWindow.document.body.innerHTML = innerContents;
      printWindow.document.head.innerHTML = document.head.innerHTML;
      printWindow.document.close();
      printWindow.focus();
      // adding setTimeout to support print in Safari
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 0);
    }
    const linkLabel = 'Download Transcript';
    this.analytics.trackEvent('trackDownloadTranscriptClick', { linkLabel });
  }
}
